import service from '~api/clue';
import * as types from '../types';

export default {
  getClueData({ commit }, payload) {
    return service.apiGetClueList(payload).then((res) => {
      if (res.data) {
        commit(types.GET_CLUE_LIST, res.data);
      }
    });
  },
  deleteClue({ commit }, payload) {
    return service.apiDeleteClue(payload);
  },
  getAllSalesman({ commit }, payload) {
    return service.apiGetAllSalesman(payload).then((res) => {
      if (res.data) {
        commit(types.GET_CLUE_SALESMAN, res.data);
      }
    });
  },
  saveSalesmanChange({ commit }, payload) {
    return service.apiSaveSalesman(payload);
  },
  addClue({ commit }, payload) {
    return service.apiAddClue(payload);
  },
  editClue({ commit }, payload) {
    return service.apiEditClue(payload);
  },
  getClueDetail({ commit }, payload) {
    return service.apiGetClueDetail(payload).then((res) => {
      if (res.data) {
        commit(types.GET_CLUE_DETAIL, res.data);
      }
    });
  },
  changeClue({ commit }, payload) {
    return service.apiChangeClueState(payload);
  },
  searchCustomer({ commit }, payload) {
    return service.apiSearchCustomer(payload).then((res) => {
      if (res.data) {
        commit(types.GET_SEARCH_CUSTOMER, res.data);
      }
    });
  },
  getTransferDetail({ commit }, payload) {
    return service.apiGetTransferDetail(payload).then((res) => {
      if (res.data) {
        commit(types.GET_TRANSFER_DETAIL, res.data);
      }
    });
  },
  addCustom({ commit }, payload) {
    return service.apiAddClueCustom(payload);
  },
  connectToCustom({ commit }, payload) {
    return service.apiConnectToCustom(payload);
  },
  getClueVisit({ commit }, payload) {
    return service.apiGetClueVisit(payload).then((res) => {
      if (res.data) {
        commit(types.GET_CLUE_VISIT, res.data);
      }
    });
  },
};
